import React from 'react';
import PropTypes from 'prop-types';
import CurrentPageContext from 'website/contexts/CurrentPageContext';
import { Col, Container, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { Modal } from '@storable/canaveral-components';
import Button from '../../../../modules/react/components/stateless/Button';
import ClassSelector from '../ClassSelector';
import CouponStyleTab from '../CouponStyleTab';
import styles from '../../../../website/widgets/dynamic/Coupon/styles.scss';
import styling from './EditCouponModal.scss';

const prepareState = function ({
  color, colors, style, text, title,
}) {
  // Create an element with the html string given for 'text' as the innerHTML.
  const textElement = document.createElement('span');
  textElement.innerHTML = text;
  // Get the class off the surrounding component.
  const textClass = textElement.firstChild.getAttribute('class');
  // If a class was found, split it to get previously selected class options
  const selectedTextOptions = textClass ? textClass.split(' ') : [];

  // Repeat for 'title'.
  const titleElement = document.createElement('span');
  titleElement.innerHTML = title;
  const titleClass = titleElement.firstChild.getAttribute('class');
  const selectedTitleOptions = titleClass ? titleClass.split(' ') : [];
  let colorState = color;
  if (!color || color === 'primary') {
    colorState = colors.primary;
  } else if (color === 'secondary') {
    colorState = colors.secondary;
  }
  return {
    color: colorState,
    selectedTextOptions,
    selectedTitleOptions,
    showColorField: false,
    style,
    text: textElement.textContent,
    textClass,
    title: titleElement.textContent,
    titleClass,
  };
};

export default class EditCouponModal extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    colors: PropTypes.shape({
      primary: PropTypes.string.isRequired,
      secondary: PropTypes.string.isRequired,
      tertiary: PropTypes.string.isRequired,
    }).isRequired,
    facilityId: PropTypes.string,
    style: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    onCancelEdit: PropTypes.func,
    onFinishEdit: PropTypes.func,
    onClose: PropTypes.func,
    renderCouponStyle: PropTypes.func,
    showEditCoupon: PropTypes.bool,
    currencySymbol: PropTypes.string,
  };

  state = prepareState(this.props);

  static contextType = CurrentPageContext;

  save = () => {
    const { colors: { primary, secondary }, facilityId } = this.props;
    let { color, text, title } = this.state;
    const { style, textClass, titleClass } = this.state;
    if (textClass) {
      text = `<div class="${textClass}">${text}</div>`;
    } else {
      text = `<div>${text}</div>`;
    }
    if (titleClass) {
      title = `<div class="${titleClass}">${title}</div>`;
    } else {
      title = `<div>${title}</div>`;
    }
    if (color === primary) {
      color = 'primary';
    } else if (color === secondary) {
      color = 'secondary';
    }
    this.props.onFinishEdit({
      color, style, text, title, facilityId,
    });
  }

  handleCancelEdit = () => {
    this.props.onClose();
    this.props.onCancelEdit();
  }

  handleChange(field) {
    return (selectedOptions) => {
      const newClass = selectedOptions.join(' ');
      if (field === 'title') {
        this.setState({ selectedTitleOptions: selectedOptions, titleClass: newClass });
      } else {
        this.setState({ selectedTextOptions: selectedOptions, textClass: newClass });
      }
    };
  }

  handleStyleChange = (style) => {
    this.setState({ style });
  }

  handleColorChange = ({ value }) => {
    if (value === 'custom') {
      this.setState({ showColorField: true });
    } else {
      this.setState({ color: value });
    }
  }

  render() {
    const { colors, renderCouponStyle, showEditCoupon, currencySymbol } = this.props;
    const {
      color,
      style,
      selectedTextOptions,
      selectedTitleOptions,
      showColorField,
      text,
      textClass,
      title,
      titleClass,
    } = this.state;

    const { primaryColor } = this.context;

    return (
      <Modal
        show={showEditCoupon}
        onDismiss={this.handleCancelEdit}
        aria-labelledby="edit-coupon-modal"
      >
        <Modal.Header>
          <Modal.Title>Edit Coupon</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.coupon}>
          <Tabs id="coupon-edit-modal-tab" defaultActiveKey={1} className={styling.description}>
            <Tab title="Text" eventKey={1}>
              <div className={styling.description}>
                Click the coupon and edit the text outlined.
              </div>
              {renderCouponStyle({ style, color, currencySymbol, primaryColor })}
              <Container>
                <Row>
                  <Col className={`${styling.editFields} col col-sm-8`}>
                    {style === 'special-offer' || style === 'gift-tag' ?
                      <div>
                        <div>
                          <Form.Control
                            as="textarea"
                            className={`${titleClass} ${styling.titleOne}`}
                            maxLength="20"
                            value={title}
                            onChange={({ target }) => this.setState({ title: target.value })}
                            style={{ color: color || colors.primary }}
                          />
                        </div>
                        <div>
                          <Form.Control
                            as="textarea"
                            className={`${textClass} ${styling.textOne}`}
                            maxLength="119"
                            value={text}
                            onChange={({ target }) => this.setState({ text: target.value })}
                          />
                        </div>
                      </div> :
                      <div>
                        <Col xs={6} className="col-xs-6">
                          <Form.Control
                            as="textarea"
                            className={`${titleClass} ${styling.titleTwo}`}
                            maxLength="20"
                            value={title}
                            onChange={({ target }) => this.setState({ title: target.value })}
                          />
                        </Col>
                        <Col xs={6} className="col-xs-6">
                          <Form.Control
                            as="textarea"
                            className={`${textClass} ${styling.textTwo}`}
                            maxLength="119"
                            value={text}
                            onChange={({ target }) => this.setState({ text: target.value })}
                          />
                        </Col>
                      </div>}
                  </Col>
                  <Col xs={4} className={`${styling.formatting} col col-sm-4`}>
                    <Form.Label className={styling.formattingLabel}>Offer formatting</Form.Label>
                    <ClassSelector
                      className={styling.selectOptions}
                      handleChange={this.handleChange('title')}
                      instanceId="title-formatting"
                      selectedOptions={selectedTitleOptions}
                    />
                    <Form.Label className={styling.formattingLabel}>Details formatting</Form.Label>
                    <ClassSelector
                      className={styling.selectOptions}
                      handleChange={this.handleChange('text')}
                      instanceId="text-formatting"
                      selectedOptions={selectedTextOptions}
                    />
                  </Col>
                </Row>
              </Container>
            </Tab>
            <Tab title="Coupon Style" eventKey={2} className={styling.image}>
              <CouponStyleTab
                color={color}
                colors={colors}
                showColorField={showColorField}
                style={style}
                handleStyleChange={this.handleStyleChange}
                handleColorChange={this.handleColorChange}
                renderCouponStyle={renderCouponStyle}
                currencySymbol={currencySymbol}
              />
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={this.handleCancelEdit}>Cancel</Button>
          <Button
            variant="success"
            onClick={this.save}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
